"use client";

import { CategoryDto } from "@/__generated__/sdk";
import InfoCircleIcon from "@/app/_components/Icons/InfoCircleIcon";
import { Close } from "@mui/icons-material";
import { Box, Button, DialogContent, DialogTitle, Icon, IconButton, Stack, SwipeableDrawer, Typography } from "@mui/material";
import DOMPurify from "isomorphic-dompurify";
import React from "react";

type Props = {
  category: CategoryDto;
};
export default function CategoryGuide({ category }: Props) {
  const hasGuide = Boolean(category.guideTitle && category.guideContent);
  const [open, setOpen] = React.useState(false);
  if (!hasGuide) {
    return <></>;
  }

  return (
    <>
      <Button
        onClick={() => {
          setOpen((e) => !e);
        }}
        sx={{
          borderRadius: 150,
          backgroundColor: { md: "info.50", xs: "unset" },
          pr: 1.5,
        }}
        color="info"
        size="small"
        disableElevation
        variant="text"
        startIcon={
          <Icon fontSize="small">
            <InfoCircleIcon />
          </Icon>
        }
      >
        {category.guideTitle}
      </Button>

      <SwipeableDrawer
        PaperProps={{
          sx: (theme) => ({
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            minHeight: "80%",
            maxHeight: "90%",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            width: {
              xs: "100%",
              sm: "100%",
              md: theme.breakpoints.values.md,
              lg: theme.breakpoints.values.lg,
            },
          }),
        }}
        ModalProps={{
          keepMounted: false,
          slotProps: {},
        }}
        anchor={"bottom"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onOpen={() => {}}
        disableDiscovery={true}
        hysteresis={0}
        disableSwipeToOpen={true}
        swipeAreaWidth={0}
      >
        <DialogTitle component={"div"} sx={{ p: 0, flexShrink: 0 }}>
          <Stack>
            <Stack direction={"row"} sx={{ mt: 1 }} alignItems={"center"} justifyContent={"center"}>
              <Box width={"45px"} height={"5px"} sx={{ borderRadius: 50, backgroundColor: "grey.100" }}></Box>
            </Stack>
            <Stack>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
                <Typography variant="h5">{category.guideTitle}</Typography>
                <IconButton
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <Close />
                </IconButton>
              </Box>
            </Stack>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ p: 0, px: 1.5, flex: 1, overflow: "auto" }}>
          {category.guideContent && (
            <Stack>
              <div
                className="ck-content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(category.guideContent, {
                    ADD_TAGS: ["iframe"],
                    ADD_ATTR: ["src", "webkitallowfullscreen", "mozallowfullscreen", "allowfullscreen"],
                  }),
                }}
              ></div>
            </Stack>
          )}
        </DialogContent>
        <Box sx={{ px: 1.5, pb: 2, pt: 1, flexShrink: 0 }}>
          <Button fullWidth variant="contained" size="large" disableElevation onClick={() => setOpen(false)} sx={{ borderRadius: 50 }}>
            بستن
          </Button>
        </Box>
      </SwipeableDrawer>
    </>
  );
}
